import {
   ReceptionServiceMarkAsRemovedCommand,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';
import { BoundServiceRemoveByReceptionServiceIdCommand } from '@dreryk/egabinet-patient-portal-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { commonTranslationKeys, PromiseVoidFunction } from '@dreryk/react-common';

import { receptionServiceTranslationKeys } from '../../../translations';

type ReceptionServiceRemoveActionRenderProps = {
   removeReceptionService: () => Promise<void>;
};

type ReceptionServiceRemoveActionProps = {
   id: ReceptionServiceId;
   children: (renderProps: ReceptionServiceRemoveActionRenderProps) => JSX.Element;
};

export const ReceptionServiceRemoveAction = (props: ReceptionServiceRemoveActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new ReceptionServiceMarkAsRemovedCommand();
         command.id = props.id;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(ReceptionServiceWithPractitionersSimpleQuery);
            dispatchSnackbarPositiveEvent(
               receptionServiceTranslationKeys.table.remove.receptionService.confirmation.snackbar
            );
         },
      }
   );

   return props.children({
      removeReceptionService: executeAsync,
   });
};

type BoundServiceRemoveActionRenderProps = {
   removeBoundService: () => Promise<void>;
};

type BoundServiceRemoveActionProps = {
   id: ReceptionServiceId;
   children: (renderProps: BoundServiceRemoveActionRenderProps) => JSX.Element;
   onSuccess: PromiseVoidFunction;
};

export const BoundServiceRemoveAction = (props: BoundServiceRemoveActionProps): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new BoundServiceRemoveByReceptionServiceIdCommand();
         command.receptionServiceId = props.id;
         return command;
      },
      {
         onSuccess: props.onSuccess,
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(commonTranslationKeys.unexpectedErrorHasOccurred);
         },
      }
   );

   return props.children({
      removeBoundService: executeAsync,
   });
};
